export default __webpack_public_path__ + "static/media/trace.f9a98725.png";